import React from 'react'
import { Checkbox } from '@mantine/core'

interface TermsCheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  termsContent: React.ReactNode
}

export default function TermsCheckbox({ checked, onChange, termsContent }: TermsCheckboxProps) {
  return (
    <Checkbox
      mt="md"
      color={'#4086FF'}
      label={termsContent}
      checked={checked}
      onChange={(event) => onChange(event.currentTarget.checked)}
    />
  )
}
